module.exports = __webpack_public_path__ + "media/hph-24-11_research.5bf5a556.mp4";